/**
 * LogoutConfirmModal Component
 * 
 * Çıkış onay modalı.
 */

import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

export const LogoutConfirmModal = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
      data-testid="logout-confirm-modal"
    >
      <Card className="bg-gray-900 border-2 border-red-500 max-w-md w-full">
        <CardContent className="p-6">
          <h3 className="text-xl font-bold text-white mb-6">
            {t('modals.logout_confirm_title')}
          </h3>
          
          <div className="flex gap-4">
            <Button
              onClick={onClose}
              variant="outline"
              className="flex-1 border-gray-600 text-gray-300 hover:bg-gray-800"
              data-testid="logout-cancel-btn"
            >
              {t('common.cancel')}
            </Button>
            <Button
              onClick={onConfirm}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white"
              data-testid="logout-confirm-btn"
            >
              {t('common.yes')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LogoutConfirmModal;
